import { cosemApi } from '@services/providers/cosem';
import { LoginRequest, LoginResponse, User, ForgotPasswordRequest, ResetPasswordRequest } from './auth.types';
import { ApiResponse } from '@services/providers/cosem.types';

export const authApi = cosemApi.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation<ApiResponse<LoginResponse>, LoginRequest>({
            query: (credentials) => ({ url: '/core/auth/login', method: 'POST', body: credentials }),
            transformResponse: (response: ApiResponse<LoginResponse>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        getMe: builder.mutation<ApiResponse<User>, undefined>({
            query: () => ({
                url: `/core/user/me`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<User>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        resetPassword: builder.mutation<ApiResponse<LoginResponse>, ResetPasswordRequest>({
            query: (credentials) => ({ url: '/core/auth/reset-password', method: 'POST', body: credentials }),
            transformResponse: (response: ApiResponse<LoginResponse>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        forgotPassword: builder.mutation<ApiResponse<void>, ForgotPasswordRequest>({
            query: (credentials) => ({ url: '/core/auth/forgot-password', method: 'POST', body: credentials }),
            transformResponse: (response: ApiResponse<void>) => ({
                code: response.code,
                status: response.status,
                data: undefined
            })
        })
    })
});

export const { useLoginMutation, useGetMeMutation, useResetPasswordMutation, useForgotPasswordMutation } = authApi;
